var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-divider'),_c('div',{staticStyle:{"padding-top":"8px"}},[_c('el-radio-group',{attrs:{"size":_vm.size},on:{"input":_vm.change},model:{value:(_vm.map),callback:function ($$v) {_vm.map=$$v},expression:"map"}},[_c('el-radio',{attrs:{"label":"Baidu Map"}}),_c('el-radio',{attrs:{"label":"Google Map"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }